var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"content"},[_c('cpt-header'),_c('el-container',[_c('el-main',[_vm._v("new")])],1),_c('cpt-bottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }